var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: ''},"title":_vm.$t('property.handover.text')}}),_c('List',{attrs:{"dataList":_vm.handoverData,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'sale_price', type: 'currency', sign: '$'}, {name: 'handover_date', type: 'date'}, {name: 'status', color: true}],"fields":[ ("property: " + (_vm.$t('property.text'))), ("sale: " + (_vm.$t('sale.text'))), 
          ("sale_price: " + (_vm.$t('general.sale_price'))), ("notation: " + (_vm.$t('general.notation'))), 
          ("handover_date: " + (_vm.$t('general.date'))), ("status: " + (_vm.$t('property.status')))
        ],"more":{
          sub: [{
            name: 'property.cancelation.approve', icon: 'bx bx-check-circle', action: 'approve', link: 'commission-paid', column: 'id', show: {column: 'property_handover_status_id', value: 1}
          },{
            name: 'property.cancelation.denie', icon: 'bx bx-x-circle', action: 'denie', link: 'commission-paid', column: 'id', show: {column: 'property_handover_status_id', value: 1}
          },{
            name: 'invoice.print', icon: 'bx bx-printer', link: 'commission-print', column: 'id', target: '_blank'
          }] 
        },"filter":{
          search: ['commissions.code', 'commissions.name', 'properties.code'],
          dropdown: [],
          date: {
            title: 'general.date',
            field: 'commissions.created_by'
          }
        }},on:{"more":_vm.moreClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }